import ProcessRoutes from "./process";
import QueryContainerRoutes from "./query_container";

export default [
    ...ProcessRoutes,
    ...QueryContainerRoutes
]
